// Global scroll position storage
let globalScrollPosition = null

export default {
  methods: {
    scrollToTheTop () {
      globalScrollPosition = document.documentElement.scrollTop || document.body.scrollTop
      document.documentElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    restoreScrollPosition () {
      if (globalScrollPosition !== null && globalScrollPosition !== undefined) {
        document.documentElement.scrollTo({
          top: globalScrollPosition,
          behavior: 'smooth'
        })
      }
      globalScrollPosition = null
    }
  }
}
